/* Tab geometry/colors mirror features/chat/components/ThreadTabs.module.css
   (the established topbar-tab look) — kept as a separate module so content
   doesn't depend on chat's thread-specific styles. */

.tabs {
    display: flex;
    align-items: stretch;
    align-self: stretch;
    gap: var(--mantine-spacing-lg);
    /* Center within the full topbar (data-fullbleed opts out of the
       thread-width constrainer) using the same max-width as
       .checklistWrapper, so the tabs left-align with the content below.
       When the pane is too narrow for that, the topbar's edge padding
       clamps the tabs to just right of the chrome buttons. */
    width: 100%;
    max-width: var(--app-max-width);
    margin-inline: auto;
    /* Same left padding as the checklist components (.checklistConfig has
       1rem), so the tabs align with the content text below. */
    padding-left: var(--mantine-spacing-md);
}

.tab {
    display: inline-flex;
    align-items: center;
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
    border-bottom: 2px solid transparent;
    /* Pull the tab down by 1px so its bottom border overlaps the topbar's
       bottom border — the active indicator sits exactly on the gneis line. */
    margin-bottom: -1px;
    font-size: var(--mantine-font-size-md);
    color: var(--mantine-color-gneis-8);
    text-decoration: none;
    transition:
        color 150ms ease,
        background-color 150ms ease;
}

.tab:hover {
    color: var(--mantine-color-dibblue-9);
    /* Same hover fill as the TopBar icon buttons beside the tabs. */
    background-color: var(--mantine-color-gneis-1);
}

.tab[data-active] {
    color: var(--mantine-color-dibblue-9);
    border-bottom-color: var(--mantine-color-dibblue-6);
    font-weight: 600;
}
